import { createAjaxAction } from "../../Common/_actions/AjaxAction";
import { CollectionPayload } from "../_stores/CollectionStore";
import { EditCollection, EditManyCollections, RemoveCollection } from "./CollectionStoreActions";
import { appendBatchProductDesignSelection, type BatchProductDesignSelection } from "./ProductDesignActions";
import { InvalidatePaginationData } from "./UserDataActions";

export enum CollectionActionType {
  FetchCollections = 'COLLECTION_FETCH_COLLECTIONS',
  CreateCollection = 'COLLECTION_CREATE_COLLECTION',
  UpdateCollection = 'COLLECTION_UPDATE_COLLECTION',
  DeleteCollection = 'COLLECTION_DELETE_COLLECTION',
  BatchAddToCollection = 'COLLECTION_BATCH_ADD_TO_COLLECTION',
  BatchRemoveFromCollection = 'COLLECTION_BATCH_REMOVE_FROM_COLLECTION',
}

export const FetchCollections = () => createAjaxAction<{items: Record<string, CollectionPayload>}>(CollectionActionType.FetchCollections, {
	url: 'ajax/api/user/collections',
	method: 'GET',
	preventDuplicates: true,
	onSuccess: (response, dispatch) => {
		dispatch(EditManyCollections(response.data.items));
	},
});

export const CreateCollection = (
  name: string
) => {
  const data = new FormData()
  data.append('name', name)

  return createAjaxAction<{item: CollectionPayload}>(CollectionActionType.CreateCollection, {
    url: 'ajax/api/user/collections',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(EditCollection(response.data.item));
    },
  });
}

export const UpdateCollection = (
  collectionId: number,
  name: string,
) => {
  const data = new FormData()
  data.append('name', name)

  return createAjaxAction<{item: CollectionPayload}>(CollectionActionType.UpdateCollection, {
    url: 'ajax/api/user/collections/'+collectionId+'/update',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(EditCollection(response.data.item));
    },
  });
}

export const DeleteCollection = (
  collectionId: number,
) => {
  return createAjaxAction<{}>(CollectionActionType.DeleteCollection, {
    url: 'ajax/api/user/collections/'+collectionId+'/delete',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(RemoveCollection(collectionId));
    },
  });
}

export const BatchAddToCollection = (
  collectionId: number,
  selection: BatchProductDesignSelection,
) => {
  const data = new FormData()
  appendBatchProductDesignSelection(data, selection)

  return createAjaxAction<{item: CollectionPayload}>(CollectionActionType.BatchAddToCollection, {
    url: 'ajax/api/user/collections/'+collectionId+'/batch-add-items',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(EditCollection(response.data.item));
    },
  });
}

export const BatchRemoveFromCollection = (
  collectionId: number,
  selection: BatchProductDesignSelection,
) => {
  const data = new FormData()
  appendBatchProductDesignSelection(data, selection)

  return createAjaxAction<{item: CollectionPayload}>(CollectionActionType.BatchRemoveFromCollection, {
    url: 'ajax/api/user/collections/'+collectionId+'/batch-remove-items',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(EditCollection(response.data.item));
      dispatch(InvalidatePaginationData('productDesigns'));
    },
  });
}
